import Reveal from "./Reveal";
import InquiryForm from "./InquiryForm";
import { CONTACT } from "@/data/content";

export default function BookingCTA() {
    return (
        <section
            id="anfrage"
            data-testid="booking-section"
            className="section-y relative"
        >
            <div className="container-em">
                <div className="grid lg:grid-cols-12 gap-10 md:gap-14 items-start">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                                Buchungsanfrage
                            </span>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2
                                data-testid="booking-title"
                                className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-balance"
                            >
                                Jetzt{" "}
                                <em className="not-italic text-primary">
                                    unverbindlich
                                </em>{" "}
                                anfragen.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="mt-6 text-foreground/75 text-lg leading-relaxed">
                                Du möchtest Deinen Aufenthalt im Emsglück
                                buchen? Fülle das Formular aus – wir melden uns
                                schnellstmöglich mit einem persönlichen Angebot
                                und der aktuellen Verfügbarkeit.
                            </p>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <div className="mt-8 space-y-3">
                                <p className="font-accent text-xs uppercase tracking-[0.25em] text-foreground/60">
                                    Lieber direkt schreiben?
                                </p>
                                <a
                                    href={CONTACT.mailtoBooking}
                                    data-testid="booking-email-link"
                                    className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium border-b border-primary/40 hover:border-primary pb-1"
                                >
                                    {CONTACT.email} →
                                </a>
                            </div>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
                                {[
                                    ["24 h", "Antwortzeit"],
                                    ["ab 3", "Nächte"],
                                    ["4,9", "km z. Meyer Werft"],
                                ].map(([v, l]) => (
                                    <div
                                        key={l}
                                        className="rounded-2xl border border-border/60 bg-card px-4 py-4 text-center"
                                    >
                                        <p className="font-display text-2xl text-foreground leading-none">
                                            {v}
                                        </p>
                                        <p className="mt-1 text-[10px] uppercase tracking-[0.18em] font-accent text-foreground/55">
                                            {l}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7">
                        <Reveal>
                            <InquiryForm />
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
